<template>
    <div :class="{ [value]: true }" class="filter-bottom-sheet-viewport" @click.stop>
        <div ref="sheet" :class="{ [value]: true, dragged }" class="filter-bottom-sheet">

            <div v-touch:end="end"
                 v-touch:moving="moving"
                 v-touch:start="start"
                 class="thumb-container">
                <div class="thumb"
                ></div>
            </div>
            <div class="header">
                <slot name="header" />
            </div>
            <div class="content">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
import { hide, show } from '@dsee/util/scrollbar.js';

const HIDDEN = 'HIDDEN';
const HALF_VISIBLE = 'HALF_VISIBLE';
const VISIBLE = 'VISIBLE';

let containerId = 0;


function getTouchEvent($event) {
    if (!$event)
        return;

    const touches = $event.touches ?? [];
    return touches[0];
}


export default {
    props: {
        value: {
            type: String,
            default: HIDDEN,
        },
    },
    data() {
        return {
            dragged: false,
        };
    },
    computed: {
        opened() {
            return this.value === VISIBLE;
        },
        shortOpened() {
            return this.value === HALF_VISIBLE;
        },
        hide() {
            return this.value === HIDDEN;
        },
    },
    methods: {
        moving($event) {
            const touch = getTouchEvent($event);
            this.$refs.sheet.style.top = `${ touch.clientY }px`;
        },
        start($event) {
            this.$options.$start = getTouchEvent($event);
            this.dragged = true;
        },
        end($event) {
            this.$refs.sheet.style.removeProperty('top');

            this.dragged = false;
            this.$options.$touch = null;

            const end = $event.changedTouches[0];
            const start = this.$options.$start;
            const diff = Math.abs(start.clientY - end.clientY);

            if (diff < 20)
                return;

            if (end.clientY < start.clientY) {
                if (this.opened)
                    return;

                // top drag
                this.$emit('input', VISIBLE);
                return;
            }

            const bottomDistance = Math.abs(document.documentElement.clientHeight - end.clientY);
            if (bottomDistance < 80) {
                // full hide
                this.$emit('input', HIDDEN);
                return;
            }

            if (this.opened) {
                this.$emit('input', HALF_VISIBLE);
                return;
            }

            if (this.shortOpened)
                this.$emit('input', HIDDEN);
        },
        onMouseEvent(e) {
            if ((this.opened || this.shortOpened) && !this.$refs.sheet.contains(e.target)) {
                this.$emit('input', HIDDEN);
            }
        },
    },
    watch: {
        value(val) {
            if (val === HIDDEN) {
                show(this.$options._id);
                return;
            }

            hide(this.$options._id);
        },
    },
    created() {
        this.$options._id = 'bottom-sheet-' + (++containerId);
    },
    mounted() {
        document.addEventListener('click', this.onMouseEvent, true);
    },
    beforeDestroy() {
        this.$emit('input', HIDDEN);
    },
};
</script>

<style lang="scss" scoped>

.filter-bottom-sheet-viewport {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 3;
    background: rgba(0, 0, 0, 0.4);
    transition: all .1s linear;
    opacity: 1;
    visibility: visible;

    &.HIDDEN {
        visibility: hidden;
        opacity: 0;
    }
}

.filter-bottom-sheet {
    position: fixed;
    width: 100%;
    bottom: -1px;
    background: #FFFFFF;
    box-shadow: 0px -4px 16px rgba(28, 41, 61, 0.2);
    border-radius: 24px 24px 0 0;
    transition: all .1s linear;
    z-index: 3;
    left: 0;

    &.HIDDEN {
        top: 110vh;
    }

    &.HALF_VISIBLE {
        top: 70vh;
        max-height: 50%;
    }

    &.VISIBLE {
        top: 56px;
        border-radius: 0;
    }

    &.dragged {
        max-height: unset;
        transition: none;
    }
}

.thumb-container {
    padding: 8px;
    display: flex;
    align-items: start;
    justify-content: center;

    .thumb {
        width: 100px;
        height: 4px;
        background: rgba(16, 24, 40, 0.25);
        border-radius: 100px;
    }
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    box-sizing: border-box;

    .title {
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
    }
}

.content {
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    overflow-y: auto;
    height: calc(100% - 82px);
}
</style>
